// src/pages/home/views/Home.view.tsx
import React from "react";
import Header from "../../../components/header/Header";
import Profile from "../../../components/global/Profile";
import Footer from "../../../components/footer/Footer";
import { HomeViewProps } from "../types";
import { HomeContainer, HeroSection } from "../Home.styled";

export function HomeView({ profileData }: HomeViewProps) {
  return (
    <HomeContainer>
      <Header />
      <main style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <HeroSection>
          <Profile
            name={profileData.name}
            role={profileData.role}
            description={profileData.description}
            imageSrc={profileData.imageSrc}
            socialLinks={profileData.socialLinks}
            cvUrl={profileData.cvUrl}
          />
        </HeroSection>
      </main>
      <Footer socialLinks={profileData.socialLinks} cvUrl={profileData.cvUrl} />
    </HomeContainer>
  );
}

export default HomeView;
